import ApiService from "@/core/services/api.service";
import {SET_ERROR} from "../auth.module";

const _ = require('lodash');

export const GET_ERROR_LIST = "report-error-list";
export const GET_TOTAL_ERROR = "total";
export const GET_ERROR_RESPONSE_HANDLING_LIST = "report-error-response-handling-list";
export const GET_TOTAL_ERROR_RESPONSE_HANDLING = "total-error-response-handling";
export const EXPORT_ERROR_LIST = "export-error"
export const EXPORT_ERROR_LIST_FEEDBACK = "export-error-feedback"
export const EXPORT_ERROR_LIST_V2 = "export-error-v2"
export const EXPORT_ERROR_LIST_FEEDBACK_V2 = "export-error-feedback-v2"
export const GET_TYPE_ERROR = "get-list-error-by-process"
export const GET_LIST_ERROR = "get-list-error"
export const DELETE_ERROR = "delete-error"
export const EDIT_ERROR = "edit-error"
export const BULK_CANCEL_ERROR = "bulk-cancel-error"
export const RESTORE_ERROR = "restore-error"

export const GET_LIST_TYPE_ERROR = "/error-type-list"
export const ADD_NEW_ERROR = "/add-error-class"
export const CONFIRM_ERROR = 'CONFIRM_ERROR'
export const RECOVERY_ERROR = 'RECOVERY_ERROR'
export const CONFIRM_MANY_ERROR = 'CONFIRM_MANY_ERROR'
export const CANCEL_ERROR = 'CANCEL_ERROR'
export const TEACHER_ERROR_LIST = 'TEACHER_ERROR_LIST'
export const GET_DETAIL_ERROR = 'GET_DETAIL_ERROR'
export const GET_LEARNING_SITUATION = 'GET_LEARNING_SITUATION'
export const GET_DETAIL_RESULT_SITUATION = 'GET_DETAIL_RESULT_SITUATION'
export const GET_ISSUES_OF_QUALITY = 'GET_ISSUES_OF_QUALITY'
export const POST_HANDLE_RESULT = 'POST_HANDLE_RESULT'
export const GET_HANDLE_HISTORY = 'GET_HANDLE_HISTORY'
export const GET_SUMMARY_REPORT = 'GET_SUMMARY_REPORT'
export const GET_GROUP_LECTURER_LIST = 'GET_GROUP_LECTURER_LIST'
export const GET_LECTURER_LIST = 'GET_LECTURER_LIST'
export const GET_TEACHING_REPORT = 'GET_TEACHING_REPORT'
export const GET_CENTER_LIST = 'GET_CENTER_LIST'
export const GET_COURSE_LIST = 'GET_COURSE_LIST'
export const GET_ERROR_REPORT_DETAIL = 'GET_ERROR_REPORT_DETAIL'
export const EXPORT_ERROR_LIST_LEADER_RADAR = 'EXPORT_ERROR_LIST_LEADER_RADAR'

const state = {
    errors: null
};

const getters = {};

const actions = {
    [GET_ERROR_LIST](context, credentials) {
        return new Promise((resolve) => {
            ApiService.query("/error-list", credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch((res) => {
                    console.log(res);
                });
        });
    },
    [GET_TOTAL_ERROR](context, credentials) {
        return new Promise((resolve) => {
            ApiService.post(GET_TOTAL_ERROR, credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch((res) => {
                    console.log(res);
                });
        });
    },
    
    [GET_ERROR_RESPONSE_HANDLING_LIST](context, credentials) {
        return new Promise((resolve) => {
            ApiService.query("/error-list-response-handling", credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch((res) => {
                    console.log(res);
                });
        });
    },
    [GET_TOTAL_ERROR_RESPONSE_HANDLING](context, credentials) {
        return new Promise((resolve) => {
            ApiService.post(GET_TOTAL_ERROR_RESPONSE_HANDLING, credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch((res) => {
                    console.log(res);
                });
        });
    },
    [EXPORT_ERROR_LIST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(EXPORT_ERROR_LIST, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [EXPORT_ERROR_LIST_FEEDBACK](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(EXPORT_ERROR_LIST_FEEDBACK, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [EXPORT_ERROR_LIST_V2](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(EXPORT_ERROR_LIST_V2, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [EXPORT_ERROR_LIST_FEEDBACK_V2](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(EXPORT_ERROR_LIST_FEEDBACK_V2, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },
    [GET_LIST_TYPE_ERROR](context, credentials) {
        return new Promise((resolve) => {
            ApiService.query(GET_LIST_TYPE_ERROR, credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch((res) => {
                    console.log(res);
                });
        });
    },
    [ADD_NEW_ERROR](context, credentials) {
        return new Promise((resolve) => {
            ApiService.post(ADD_NEW_ERROR, credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch((res) => {
                    console.log(res);
                });
        });
    },
    [GET_LIST_ERROR](context, credentials) {
        return new Promise((resolve) => {
            ApiService.query(GET_LIST_ERROR, credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch((res) => {
                    console.log(res);
                });
        });
    },

    [DELETE_ERROR](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(DELETE_ERROR, payload).then(({ data }) => {
                resolve(data);
            }).catch((response) => {
                reject(response)
            });
        })
    },

    [EDIT_ERROR](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(EDIT_ERROR, payload).then(({ data }) => {
                resolve(data);
            }).catch((response) => {
                reject(response)
            });
        })
    },

    async [BULK_CANCEL_ERROR]({ commit }, payload) {
        try {
            const response = await ApiService.post(BULK_CANCEL_ERROR, payload);
            return response.data;
        } catch (error) {
            console.error('Error in bulk cancel errors:', error);
            return { error: true };
        }
    },

    async [RESTORE_ERROR]({ commit }, payload) {
        try {
            const response = await ApiService.post(RESTORE_ERROR, payload);
            return response.data;
        } catch (error) {
            console.error('Error in undo cancel error:', error);
            return { error: true };
        }
    },
    [CONFIRM_ERROR](context, data) {
        return new Promise((resolve,reject) => {
            ApiService.post(`warning-errors/${data.id}/confirm`, data.payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [RECOVERY_ERROR](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.post(`warning-errors/restore-confirmation`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [CONFIRM_MANY_ERROR](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.post(`warning-errors/bulk-confirm`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [CANCEL_ERROR](context, data) {
        return new Promise((resolve,reject) => {
            ApiService.post(`academic/teacher-quality-issues/${data.id}/cancel`, data.payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [TEACHER_ERROR_LIST](context, credentials) {
        return new Promise((resolve,reject) => {
            ApiService.query('academic/teacher-quality-issues', credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_DETAIL_ERROR](context, id) {
        return new Promise((resolve,reject) => {
            ApiService.get('academic/teacher-quality-issues', id)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_LEARNING_SITUATION](context, id) {
        return new Promise((resolve,reject) => {
            ApiService.get('classrooms/students', id)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_DETAIL_RESULT_SITUATION](context, {classroom_id, student_id}) {
        return new Promise((resolve,reject) => {
            ApiService.query(`classrooms/${classroom_id}/student/${student_id}/latest-exam-result`)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_ISSUES_OF_QUALITY](context, idIssue) {
        return new Promise((resolve,reject) => {
            ApiService.query(`academic/teacher-quality-issues/${idIssue}/handling-options`)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [POST_HANDLE_RESULT](context, data) {
        return new Promise((resolve,reject) => {
            ApiService.post(`academic/teacher-quality-issues/${data.id}/handle`, data.payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_HANDLE_HISTORY](context, idIssue) {
        return new Promise((resolve,reject) => {
            ApiService.query(`academic/teacher-quality-issues/${idIssue}/history`)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_SUMMARY_REPORT](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.query(`academic/teaching-report/summary`,payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_GROUP_LECTURER_LIST](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.query(`academic/teacher-quality-issues/take-group-teacher`,payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_LECTURER_LIST](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.query(`academic/teacher-quality-issues/take-teachers`,payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_TEACHING_REPORT](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.query(`academic/teaching-report/trend`,payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_CENTER_LIST](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.query(`centers/get-brand-e`, payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_COURSE_LIST](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.query(`course/get-list`,payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [GET_ERROR_REPORT_DETAIL](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.query(`academic/teaching-report/detail`,payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [EXPORT_ERROR_LIST_LEADER_RADAR](context, payload) {
        return new Promise((resolve,reject) => {
            ApiService.query(`academic/teacher-quality-issues/export-issue`,payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    }
}

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
